import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import AddressForm from "../AddressForm";
import { ModalWindow } from "ui-core-dashboard";
import { isEmpty, get } from "lodash";
import cx from "classnames";
import baseService from "services/BaseService";
import Loader from "../common/Loader";
import { StreetModes } from "constants/index";

import "./styles.scss";

const AddressModal = props => {
    const {
        t,
        address,
        onClose = () => {},
        customerId,
        customerObjectType,
        onAddressSave,
        staticBlockFormKey,
        withoutAddressType,
        defaultType = "",
        inputKey,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [streetMode, setStreetMode] = useState();
    const [errors, setErrors] = useState(null);
    const [values, setValues] = useState(null);
    const [buildingNumbers, setBuildingNumbers] = useState([]); // dict numbers to check upon buildId param save

    const isDisabled = isLoading || !isEmpty(errors);

    function handleValues(values) {
        setValues(values);
    }

    function handleErrors(errors) {
        setErrors(errors);
    }

    async function handleAddressSave() {
        setIsLoading(true);

        const buildingNumberValue = get(values, "buildingNumber");
        let buildingNumber =
            buildingNumberValue && typeof buildingNumberValue === "object"
                ? buildingNumberValue.label
                : buildingNumberValue;

        // we need buildId to pass on save, but for manual adresses it should be null
        // if buildId is in current buildingNumbers dict - we should save this id
        // otherwise buildId should be null
        
        let buildId = get(buildingNumberValue, "value", null);
        const isBuildIdInDict = buildId && buildingNumbers.find(item => item.id === buildId);

        if (!isBuildIdInDict) {
            buildId = null;
        }

        const buildingNumberCreatable = get(values, "buildingNumberCreatableInput");
        if (buildingNumberCreatable) {
            buildingNumber = buildingNumberCreatable;
        }

        const zipCodeValue = get(values, "zipCode");
        let zipCode = zipCodeValue && typeof zipCodeValue === "object" ? zipCodeValue.label : zipCodeValue;
        const zipCodeCreatable = get(values, "zipCodeCreatableInput");
        if (zipCodeCreatable) {
            zipCode = zipCodeCreatable;
        }

        try {
            const data = {
                customerId,
                streetId: get(values, "street") || "",
                type: get(values, "type") || get(address, "type") || defaultType,
                settlementId: get(values, "settlement"),
                street: get(values, "street") || "",
                buildId: buildingNumberCreatable ? null : buildId,
                buildingNumber: buildingNumber || "",
                apartmentNumber: get(values, "apartmentNumber") || "",
                description: get(values, "description") || "",
                kind: "urban",
                zipCode: zipCode || "",
                buildingSecondNumber: get(values, "buildingSecondNumber") || "",
                intercomNumber: "",
                floor: "",
                latitude: "",
                longitude: "",
            };

            if (address) {
                data.id = address.id;
                data.type = address.type;
            }

            // handle ref:
            // 1. check if there is no buildingNumberCreatable (text manual input active)
            // 2. if not => add refPartyId
            // 3. reset buildingNumber to have a value without ref name
            if (!buildingNumberCreatable && ![null, undefined].includes(values.buildingNumberRefPartyId)) {
                data.refPartyId = values.buildingNumberRefPartyId;
                data.buildingNumber = values.buildingNumberLabelWithoutRef;
            }

            // we need to save street first and afterwards the address
            if (streetMode === StreetModes.MANUAL) {
                const params = {
                    data: {
                        parentId: get(values, "settlement"),
                        parentType: "location",
                        name: get(values, "name"),
                        type: "street",
                        streetTypeId: get(values, "streetTypeId"),
                        guid: "",
                        sourceId: "",
                        description: "",
                    },
                    jsonType: true,
                };

                const response = await baseService.post("add_street", params);
                if (response.success && response.result) {
                    const street = response.result[0];

                    data.street = street.id;
                    data.streetId = street.id;
                } else {
                    throw new Error("Street save request error");
                }
            }
            const response = await baseService.post("customer_address_v2", { data, jsonType: true });
            if (response.success) {
                if (onAddressSave && typeof onAddressSave === "function") {
                    onAddressSave(response.result, data);
                }
                onClose();
            } else {
                throw new Error("Address save request error");
            }
        } catch (e) {
            console.error("AddressModal::handleAddressSave: Error", e);
        } finally {
            setIsLoading(false);
        }
    }

    // console.log({ customerId, customerObjectType, onAddressSave, onClose, staticBlockFormKey });

    return (
        <ModalWindow onClose={onClose} className="ordering-component-ui-core-wrapper address-modal">
            <header className="modal-window-header">
                <div className="modal-window-title">{address ? t("editAddress") : t("newAddress")}</div>
            </header>
            <div className="address-form">
                {isLoading && <Loader />}
                <AddressForm
                    address={address}
                    customerId={customerId}
                    customerObjectType={customerObjectType}
                    onValuesUpdate={handleValues}
                    onErrorsUpdate={handleErrors}
                    onStreetModeUpdate={setStreetMode}
                    withoutAddressType={withoutAddressType}
                    staticBlockFormKey={staticBlockFormKey}
                    inputKey={inputKey}
                    onBuildingNumbersUpdate={setBuildingNumbers}
                />
            </div>
            <footer className="modal-footer">
                <button
                    type="submit"
                    className={cx("btn btn-primary", { disabled: isDisabled })}
                    disabled={isDisabled}
                    onClick={handleAddressSave}
                >
                    {address ? t("save") : t("create")}
                </button>
            </footer>
        </ModalWindow>
    );
};

export default withTranslation()(AddressModal);
